import { Link } from 'react-router-dom';

const ProductsSection = () => {
  const products = [
    {
      id: 1,
      name: 'Refresco 1x25 Tecnutri - 1kg',
      category: 'Bebidas',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/05c46cb2f00fa6c3a3a7e55ef1bb9059.jpeg',
      description: 'Ótimo para refeições coletivas, vários sabores.',
      externalLink: 'https://www.tecnutrifoodservice.com.br/'
    },
    {
      id: 2,
      name: 'Mingau - 1kg',
      category: 'Mingaus',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/e3a6a795b5cc7433a7b1da36ad155f9f.png',
      description: 'Mingau cremoso e nutritivo, perfeito para o café da manhã.',
      externalLink: '/nutrare'
    },
    {
      id: 3,
      name: 'Risotos - 1kg',
      category: 'Risotos',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/47c684e1faa583cd7fd54b57ef7e9150.png',
      description: 'Mistura para o preparo de risoto (arroz à grega)',
      externalLink: '/nutrare'
    },
    {
      id: 4,
      name: 'Gelatinas Sachê - 25g',
      category: 'Gelatinas',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/09761fcf8cf9d2aa258456d234e2723a.jpeg',
      description: 'Gelatinas em sachê com sabores variados.',
      externalLink: '/enjoy'
    },
    {
      id: 5,
      name: 'Caldo de Carne - 50g',
      category: 'Caldos',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/6d50ba39fccfd23eb7d9af839328f407.jpeg',
      description: 'Caldo de carne concentrado para realçar o sabor dos pratos.',
      externalLink: '/enjoy'
    },
    {
      id: 6,
      name: 'Achocolatado Tecnutri - 1,01kg',
      category: 'Bebidas',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/dace11ecaac64b4416f4b1b55f538773.jpeg',
      description: 'Achocolatado Instantâneo, cremoso e gostoso.',
      externalLink: 'https://www.tecnutrifoodservice.com.br/'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Conheça Nossas Marcas
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Descubra nossa linha completa de produtos alimentícios desenvolvidos com a mais alta qualidade 
            e tecnologia para atender às necessidades do seu negócio.
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-product-shop>
          {products.map((product) => (
            <div key={product.id} className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden group">
              <div className="aspect-square overflow-hidden">
                <img 
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <span className="px-3 py-1 bg-blue-100 text-blue-600 text-sm font-medium rounded-full">
                    {product.category}
                  </span>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors">
                  {product.name}
                </h3>
                <p className="text-gray-600 mb-4 line-clamp-2">
                  {product.description}
                </p>
                {product.externalLink.startsWith('http') ? (
                  <a 
                    href={product.externalLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-blue-600 font-medium hover:text-blue-700 transition-colors whitespace-nowrap"
                  >
                    Ver Detalhes
                    <i className="ri-arrow-right-line ml-2"></i>
                  </a>
                ) : (
                  <Link 
                    to={product.externalLink}
                    className="inline-flex items-center text-blue-600 font-medium hover:text-blue-700 transition-colors whitespace-nowrap"
                  >
                    Ver Detalhes
                    <i className="ri-arrow-right-line ml-2"></i>
                  </Link>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* CTA removed */}
      </div>
    </section>
  );
};

export default ProductsSection;
